<template>
    <div class="container">

        <div style="height: 36px;"></div>
        <div style="display: flex;">
            <img src="../../assets/gaga/icon.png" style="width: 16vw; height: 16vw; margin-top: 4vw; margin-left: 30px;" />
            <div style="display: flex; flex-direction: column; margin-left: 7vw; width: 60vw;">
                <span style="font-size: 24px; font-weight: bold;">Local Meet & Dating App: Gaga</span>
                <span style="font-size: 18px; color: green; margin-top: 2px;">Juyi Global</span>
            </div>
        </div>

        <img src="./img/stars.png" style="margin-top: 30px; width: 90vw; margin-left: 7vw;" />

        <div class="btn" @click="btnClick">
            <span style="font-size: 14px; color: white;">Install</span>
        </div>

        <div class="img_container">
            <div style="display: flex; flex-direction: row; width: 180vw;">
                <img style="width: 30vw; border-radius: 8px;" src="./img/1.png" />
                <img style="width: 30vw; border-radius: 8px; margin-left: 20px;" src="./img/2.png" />
                <img style="width: 30vw; border-radius: 8px; margin-left: 20px;" src="./img/3.png" />
                <img style="width: 30vw; border-radius: 8px; margin-left: 20px;" src="./img/4.png" />
                <img style="width: 30vw; border-radius: 8px; margin-left: 20px;" src="./img/5.png" />
            </div>
        </div>

        <span style="margin-left: 6vw; margin-top: 30px; font-size: 19px;">
            About this app
        </span>

        <span class="content_text" style="margin-top: 24px; word-break: break-all;">
            Gaga is full of rich, happy people and things, making it easy to meet new friends and local singles. 
            Unleash your passion to connect with other like-minded people, explore, get inspired, 
            and create unforgettable moments together.</br>
            <br />
            KEY FEATURES:</br>
            √ Swipe the page to meet your favorite friends.</br>
            √ Like each other to show affection.</br>
            √ Share fun moments with friends.</br>
            √ See who's single around you.</br>
            √ Chat with friends without time limit.<br />
            <br />
            We genuinely hope you'll enjoy using the Gaga app！
        </span>


        <span style="margin-left: 6vw; margin-top: 24px; font-size: 19px;">
            Ratings and reviews
        </span>

        <img src="./img/ratings.png" style="width: 88vw; margin-left: 6vw; margin-top: 10px;" />


        <div style="display: flex; margin-top: 24px; align-items: center;">
            <div class="comments_title" style="background-color: rgb(28, 79, 122);">
                <span style="font-size: 14px;">T</span>
            </div>
            <span style="font-size: 16px; margin-left: 20px;">Thomas</span>
        </div>
        <div style="display: flex; margin-top: 20px; align-items: center;">
            <img src="./img/star_five.png" style="height: 5vw; margin-left: 6vw; margin-top: 0.5vw;"/>
            <span style="font-size: 14px; margin-left: 20px; color: gray;">October 17, 2024</span>
        </div>
        <span class="content_text" style="margin-top: 10px;">
            Gaga is really a very good dating app. It has helped me meet a lot of 
            friends and expanded my social circle. Five-star praise!
        </span>
        <span class="content_text" style="margin-top: 20px;">39 people found this review helpful</span>





        <div style="display: flex; margin-top: 30px; align-items: center;">
            <div class="comments_title" style="background-color: rgb(123, 72, 12);">
                <span style="font-size: 14px;">O</span>
            </div>
            <span style="font-size: 16px; margin-left: 20px;">Owen</span>
        </div>
        <div style="display: flex; margin-top: 20px; align-items: center;">
            <img src="./img/star_five.png" style="height: 5vw; margin-left: 6vw; margin-top: 0.5vw;"/>
            <span style="font-size: 14px; margin-left: 20px; color: gray;">August 5, 2024</span>
        </div>
        <span class="content_text" style="margin-top: 10px;">
            There are many beauties, the product experience is very good, and it is very good software.
        </span>
        <span class="content_text" style="margin-top: 20px;">16 people found this review helpful</span>




        <div style="display: flex; margin-top: 30px; align-items: center;">
            <div class="comments_title" style="background-color: rgb(23, 172, 122);">
                <span style="font-size: 14px;">G</span>
            </div>
            <span style="font-size: 16px; margin-left: 20px;">Garrick</span>
        </div>
        <div style="display: flex; margin-top: 20px; align-items: center;">
            <img src="./img/star_five.png" style="height: 5vw; margin-left: 6vw; margin-top: 0.5vw;"/>
            <span style="font-size: 14px; margin-left: 20px; color: gray;">July 4, 2024</span>
        </div>
        <span class="content_text" style="margin-top: 10px;">
            The interface is clear and the functions are simple, I like it very much!
        </span>
        <span class="content_text" style="margin-top: 20px;">87 people found this review helpful</span>






       


    <div style="width: 90vw; height: 1px; background-color: #F0F0F0; margin-top: 50px; margin-left: 5vw;">

    </div>
    <span class="bottom_title" style="margin-top: 36px;">Google play</span>
    <span class="bottom_title" style="margin-top: 16px;">Play Pass</span>
    <span class="bottom_title" style="margin-top: 16px;">Play Points</span>
    <span class="bottom_title" style="margin-top: 16px;">Gift cards</span>
    <span class="bottom_title" style="margin-top: 16px;">Redeem</span>
    <span class="bottom_title" style="margin-top: 16px;">Refund policy</span>
    <span class="bottom_title" style="margin-top: 16px;">Kids & family</span>
    <span class="bottom_title" style="margin-top: 16px;">Parent Guide</span>
    <span class="bottom_title" style="margin-top: 16px;">Family sharing</span>



    <div style="display: flex; flex-direction: row; margin-top: 50px;">
        <span style="font-size: 14px; color: gray; margin-left: 6vw;">Terms of Service</span>
        <div style="flex: 1"></div>
        <span style="font-size: 14px; color: gray;">Privacy</span>
        <div style="flex: 1"></div>
        <span style="font-size: 14px; color: gray; margin-right: 6vw;">About Google Play</span>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 30px;">
        <span style="font-size: 14px; color: gray; margin-left: 6vw;">Developers</span>
        <div style="width: 12vw;"></div>
        <span style="font-size: 14px; color: gray;">Google Store</span>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 30px; align-items: center;">
        <img src="./img/flag.png" style="height: 7vw; margin-left: 6vw;" />
        <div style="width: 3vw;"></div>
        <span style="font-size: 14px; color: gray;">United States(English(United States))</span>
    </div>


    <div style="height: 20vw;"></div>










        <!-- <div class="p_title">
            Account download !
        </div> -->
        <!-- <div style="height: 300vh; width: 100vw; background-color: aqua;"></div> -->
    </div>
</template>

<script>
import { is_weixin, isIos } from '../../common/functions';

const url_android = 'https://d1iw7x8hqclyxv.cloudfront.net/static/gaga.apk';

export default {
    created() {
        document.title = "Gaga";
    },

    methods: {
        btnClick() {
            if (is_weixin()) {
                alert('Please click on the upper right corner to open with an external browser before downloading!');
            } else {
                if (isIos()) {
                    // window.location.href = url_ios;
                    alert('Preparing...');
                } else {
                    window.location.href = url_android;
                }
            }
        }
    }
}
</script>


<style scoped>
.container {
    width: 100%;
    /* height: 100vh; */
    display: flex;
    flex-direction: column;
    /* padding: 24px 24px 24px 24px; */
    /* justify-content: center; */
    /* background-color: rebeccapurple; */
}
.p_title {
    font-size: 36px;
    font-weight: 600px;
    align-self: center;
    justify-content: center;
    margin-bottom: 100px;
    font-style: italic
}

.btn {
    display: flex;
    margin-top: 32px;
    margin-left: 6vw;
    width: 88vw;
    height: 10vw;
    background-color: #01875f;
    border-radius: 10px;
    text-align: center;
    align-items: center;
    justify-content: center;
}

.img_container {
    display: inline-block;
    overflow-x: scroll;
    flex-direction: row;
    margin-top: 80px;
    margin-left: 6vw;
    width: 88vw;
}
.img_container::-webkit-scrollbar {
    display: none;
}

.content_text {
    margin-left: 6vw;
    width: 88vw;
    font-size: 17px;
    color: #5f6368;
}

.comments_title {
    display: flex;
    width: 32px;
    height: 32px;
    border-radius: 16px;
    margin-left: 6vw;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: white;
}

.bottom_title {
    margin-left: 6vw;
    font-size: 17px;
    color: gray;
}
</style>